export enum EStorageKeys {
  'ACCESS_TOKEN' = 'access_token'
}
